import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import { convertDimensions } from '../../../../services/unit-services/dimensions/dimension-convert-service';
import { DimensionUnit } from '../../../../enums/dimension-unit';

const DimensionsColumn = ({ id: presetGroupId }) => {
  const sellerUnit = useSelector((state) => Global.selectSellerDefaultDimensionUnit(state));
  const rawDimensionUnit =
    useSelector((state) =>
      Global.selectEntitiesPresetGroupPropertyById(state, {
        profileId: presetGroupId,
        property: 'dimensionUnitOfMeasureId',
      }),
    ) || 'in';
  const isDimensionUnitImperial = (unit) => unit === DimensionUnit.Inches || unit === DimensionUnit.Inch;
  const abbreviatedDimensionUnit = isDimensionUnitImperial(sellerUnit) ? (
    <FormattedMessage {...messages.inchesAbbreviation} />
  ) : (
    <FormattedMessage {...messages.centimetersAbbreviation} />
  );
  const originalWidth =
    useSelector((state) =>
      Global.selectEntitiesPresetGroupPropertyById(state, {
        profileId: presetGroupId,
        property: 'width',
      }),
    ) || 0;
  const originalLength =
    useSelector((state) =>
      Global.selectEntitiesPresetGroupPropertyById(state, {
        profileId: presetGroupId,
        property: 'length',
      }),
    ) || 0;
  const originalHeight =
    useSelector((state) =>
      Global.selectEntitiesPresetGroupPropertyById(state, {
        profileId: presetGroupId,
        property: 'height',
      }),
    ) || 0;

  const convertedDimensions = convertDimensions(
    {
      length: originalLength,
      width: originalWidth,
      height: originalHeight,
      unit: rawDimensionUnit,
    },
    sellerUnit,
  );
  const { length, width, height } = convertedDimensions;

  if (originalWidth === 0 && originalLength === 0 && originalHeight === 0) {
    return '';
  }
  return (
    <FormattedMessage
      {...messages.dimensionsValue}
      values={{
        length,
        width,
        height,
        unit: abbreviatedDimensionUnit,
      }}
    />
  );
};

DimensionsColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.dimensionsColumn,
  name: <FormattedMessage {...messages.dimensionsColumn} />,
  id: 'dimensions',
  isSortable: false,
  render: DimensionsColumn,
};
